// extracted by mini-css-extract-plugin
export default {"tx":"b136a4d323","line":"c952ec7525"};